import React from 'react'
import { contractStatuses, typeOperations } from '../../../helpers/data-constants'

import './iconStatus.scss'

const IconStatus = ({status, newStatus, previousStatus}) => {
  if (typeof status === 'number') {
    const next = contractStatuses[newStatus] || contractStatuses['UNKNOWN'];
    const previous = contractStatuses[previousStatus] || contractStatuses['UNKNOWN'];
    const result = status === 3000 || status === 3099
    ?
      <div>
        <span className={`label ${previous.style}`}>{previous.name}</span>
        <span> → </span>
        <span className={`label ${next.style}`}>{next.name}</span> 
      </div>
    : 
      <span className={`label ${typeOperations[status].style}`}>{typeOperations[status].name}</span>
    return result
  } else {
    const v = contractStatuses[status] || contractStatuses['UNKNOWN']
    return <span className={`label ${v.style}`}>{v.name}</span>
  }
}

export default IconStatus
